import { useTranslation as useNextTranslation } from 'react-i18next';
import {
  useTranslation as useCrehanaTranslation,
  UseTranslationResult,
} from 'crehana-i18n';

/**
 * This is a helper hook created while we migrate to our own i18n implementation
 *
 * We need to force the return type because both functions return a different
 * type and it's hard to typecast locally, ideally this hook is used within pages
 * that support it.
 */
export function useTranslation<
  T extends string = string,
  U extends string = string
>(ns?: string): UseTranslationResult<T, U> {
  const crehanaT = useCrehanaTranslation<T, U>(ns);
  const nextT = useNextTranslation(ns);

  if (crehanaT) {
    return crehanaT;
  }

  // Casting to prevent ts error
  return (nextT as unknown) as UseTranslationResult<T, U>;
}
